import {graphColors} from '../../helpers/utils'

export default [
    { id: 1, value: 0, name: 'Male', color: graphColors.primary },
    { id: 2, value: 0, name: 'Female', color: graphColors.secondary }
];